import Navigation from "../Navigation/Navigation";
import Estimation from "../Estimation/Estimation";
import Packages from "../Packages/Packages";
import "./Quote.css";

function Quote() {
  return (
    <div className="quote-page">
      <Navigation />

      <section className="quote-hero">
        <div className="quote-hero-content">
          <p className="quote-eyebrow">Plan your project</p>
          <h1>Get Your  Quote</h1>
          <p>
             Explore our construction packages and estimate your project budget with Sarrathi Constructions.
          </p>
        </div>
      </section>

     

      <section className="quote-section quote-section-alt" id="packages">
        <Packages />
      </section>

       <section className="quote-section" id="estimation">
        <Estimation />
      </section>
    </div>
  );
}

export default Quote;